import { Box, Chip, Tooltip, Typography } from '@mui/material';

const FacilityAccessChips = ({
  facilities = [],
  hasAllFacilitiesAccess = false,
  visibleCount = 1,
}) => {
  if (hasAllFacilitiesAccess) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Chip
          label='All Facilities'
          size='small'
          variant='outlined'
          sx={{ maxWidth: 120 }}
        />
      </Box>
    );
  }

  if (!facilities || !Array.isArray(facilities) || facilities.length === 0) {
    return null;
  }

  const visibleFacilities = facilities.slice(0, visibleCount);
  const hiddenFacilities = facilities.slice(visibleCount);
  const hasMore = hiddenFacilities.length > 0;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        alignItems: 'center',
      }}>
      {visibleFacilities.map((facility, index) => (
        <Chip
          key={facility.id || index}
          label={facility.name}
          size='small'
          variant='outlined'
          sx={{
            maxWidth: 120,
            '& .MuiChip-label': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
        />
      ))}
      {hasMore && (
        <Tooltip
          title={
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              {facilities.map((facility, index) => (
                <Typography
                  key={facility.id || index}
                  variant='body2'
                  sx={{ color: 'inherit' }}>
                  {facility.name}
                </Typography>
              ))}
            </Box>
          }
          arrow>
          <Chip
            label={`+${hiddenFacilities.length} more`}
            size='small'
            variant='outlined'
            sx={{ cursor: 'pointer' }}
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default FacilityAccessChips;
